<template>
  <div class="w-100 h-100">
    <v-card elevation="0" outlined class="d-flex flex-column h-100" min-height="350">
      <v-card-title class="d-flex align-center">
        <v-icon color="secondary" large class="mr-2">fireplace</v-icon>
        <div class="d-flex flex-column flex-grow-1">
          <span class="primary--text monospace-font body-1 font-weight-medium">{{ $t("dashboards.hotPlayers") }}</span>
          <span class="subheader-font body-2">{{$t(`dashboards.last_${period}`)}}</span>
        </div>
        <v-btn class="ml-2 elevation-0" color="secondary" x-small :disabled="loading"
          @click="onReloadClick()">
          <v-icon small>refresh</v-icon></v-btn>
      </v-card-title>
      <v-divider class=""></v-divider>
      <div class="px-3 pt-1" style="max-height:71px;" v-if="data && data.length">
        <v-autocomplete class="" :placeholder="$t('playerRecruitment.league')" item-text="label" item-value="id"
        v-model="leagueModel" clearable
        :items="filteredLeagues" dense hide-details outlined>
        </v-autocomplete>
      </div>
      <div class="px-3 py-1" style="max-height:71px;" v-if="data && data.length">
        <v-autocomplete class="" :placeholder="$t('table.gameFlow.team')" item-text="name" item-value="id"
        v-model="teamModel" clearable
        :items="filteredTeams" dense hide-details outlined></v-autocomplete>
      </div>
      <v-divider class="mb-1"></v-divider>
      <div class="d-flex align-center pl-5 pr-3 pb-1 body-2">
        <div class="w-65">
          <span>{{$t("playerDetail.name")}}</span>
        </div>
        <div class="w-35 text-right">
          <span>{{$t("general.searches")}}</span>
        </div>
      </div>
      <v-divider class="mb-1"></v-divider>
      <div class="d-flex flex-column pl-5 pr-3 pb-1 flex-grow-1" v-if="(orderedData && orderedData.length) && !loading" style="overflow:auto;max-height:240px">
        <div class="element w-100 d-flex align-center mb-1" v-for="(d,index) in orderedData" :key="index" style="min-height:18px;">
          <div class="w-80 d-flex align-center body-2">
            <v-tooltip top color="lightSecondary lighten-4" max-width="300">
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" x-small class="mr-2" color="secondary">info_outline</v-icon>
              </template>
              <div class="d-flex flex-column body-1 black--text font-weight-bold">
                <div v-for="(c,index) of d.clients" :key="index" class="d-flex justify-space-between align-center">
                  <span class="mr-2">{{c.clientName}} </span>
                  <span class="font-weight-regular ml-2">{{c.searches}}</span>
                </div>
              </div>
            </v-tooltip>
            <div class="w-100 d-flex">
              <router-link :to="`/player/${d.playerId}`" class="font-weight-medium mr-2 text-ellipsis">{{d.playerName}}</router-link>
              <router-link :to="`/team/${d.teamId}`" class="text-ellipsis subheader-font primary--text">({{d.teamName}})</router-link>
            </div>
          </div>
          <div class="w-20 text-right body-2">
            <span >{{d.totalSearches}}</span>
          </div>
        </div>
      </div>
      <div class="d-flex justify-center align-center flex-column px-3 py-4 mb-7 text-center flex-grow-1" v-if="(!orderedData || !orderedData.length) && !loading" >
        <v-icon color="primary lighten-5" v-bind:style="{'font-size':$vuetify.breakpoint.mdAndUp ? '80px' : '60px'}">cloud_off</v-icon>
        <span class="primary--text lighten--text-2 body-1">{{$t("general.noData")}}</span>
      </div>
      <v-skeleton-loader v-if="loading" type="list-item@10" class="flex-grow-1" style="overflow:auto;max-height:240px"></v-skeleton-loader>
    </v-card>
  </div>
</template>

<script>
import StatService from "../../../services/stat.service";
import * as moment from 'moment';
import LeagueService from '../../../services/league.service';

export default {
  name: "HotPlayersWidget",
  components:{
  },
  props: {
    period:{
      type: String,
      default: "month"
    }
  },
  data() {
    return {
      loading: false,
      data: null,
      interval: null,
      leagues: [],
      leagueModel: null,
      teamModel: null
    };
  },
  computed: {
    orderedData() {
      return _.chain(this.data).filter(d => {
        let matchLeague = this.leagueModel != null ? d.leagueId === this.leagueModel : true;
        let matchTeam = this.teamModel != null ? d.teamId === this.teamModel : true;
        return matchLeague && matchTeam
      }).orderBy(["totalSearches",'playerName'],['desc','asc']).value();
    },
    filteredLeagues(){
      return _.chain(this.leagues).filter(l => {
        return _.some(this.data,(d) => d.leagueId === l.id);
      }).value();
    },
    teams(){
      return _.chain(this.data).map(d => {
        return {
          id: d.teamId,
          name: d.teamName,
          leagueId: d.leagueId
        }
      }).uniqBy('id').orderBy("name",'asc').value();
    },
    filteredTeams(){
      if(this.leagueModel){
        return _.filter(this.teams,(t) => t.leagueId === this.leagueModel)
      }
      return this.teams;
    }
  },
  filters: {
  },
  async mounted() {
    await this.getLeagues();
  },
  methods: {
    async getStats() {
      let statsResponse = await StatService.getHotPlayers(this.period);
      let stats = statsResponse.data;
      this.data =  _.chain(stats).groupBy('playerId').map((value,pId) => {
        let clients = _.chain(value).groupBy('clientId').map((v,k) => {
          return {clientId: v[0].clientId,clientName: v[0].clientName,searches: _.size(v)}
        }).value();
        return {
          playerId: pId,
          playerName: value[0].playerName,
          clients: clients,
          nClients: clients.length,
          totalSearches: _.reduce(clients,(accum,c) => accum + c.searches,0),
          teamId: value[0].teamId,
          teamName: value[0].teamName,
          leagueId: value[0].leagueId
        };
      }).filter(d => {
        let threshold = this.period === 'month' ? 20 : 10;
        return d.totalSearches >= threshold && d.playerId != 0;
      }).orderBy(["totalSearches",'playerName'],['desc','asc']).value();
      this.$forceUpdate();
    },
    toWeekDay(date){
      return moment(date,"DD/MM/YYYY").format('dddd');
    },
    toWeekDayNumber(date){
      return moment(date,"DD/MM/YYYY").weekday();
    },
    async onReloadClick(){
      this.loading = true;
      await this.getStats();
      this.loading = false;
    },
    async getLeagues(){
      let leaguesResponse = await LeagueService.getAllLeagues();
      this.leagues = _.chain(leaguesResponse.data).filter(l => l.isRegular).orderBy(['area','division','tier'],['asc','asc','asc']).value();
    }
  },
  destroyed() {
    clearInterval(this.interval);
  }
};
</script>



// WEBPACK FOOTER //
// src/views/dashboard/widgets/HotPlayersWidget.vue